export const SCROLL_AFFORDANCE_THRESHOLD_PX = 24;
export const SCROLL_AFFORDANCE_PAGE_RATIO = 0.8;
export const SCROLL_AFFORDANCE_CHEVRON_HIT_PX = 44;

export interface ScrollAffordanceState {
  showTopScrim: boolean;
  showBottomHint: boolean;
  playBob: boolean;
  hasBobbed: boolean;
}

export interface ScrollAffordanceMetrics {
  scrollTop: number;
  scrollHeight: number;
  clientHeight: number;
  reservedBottom: number;
}

export const INITIAL_SCROLL_AFFORDANCE_STATE: ScrollAffordanceState = {
  showTopScrim: false,
  showBottomHint: false,
  playBob: false,
  hasBobbed: false,
};

export function nextScrollAffordanceState(
  previous: ScrollAffordanceState,
  metrics: ScrollAffordanceMetrics,
): ScrollAffordanceState {
  const { scrollTop, scrollHeight, clientHeight, reservedBottom } = metrics;
  const hiddenBelow = scrollHeight - clientHeight - scrollTop - reservedBottom;
  const showBottomHint = hiddenBelow > SCROLL_AFFORDANCE_THRESHOLD_PX;
  const showTopScrim = scrollTop > SCROLL_AFFORDANCE_THRESHOLD_PX;
  const justShowedBottom = showBottomHint && !previous.showBottomHint;
  const playBob = justShowedBottom && !previous.hasBobbed;

  return {
    showTopScrim,
    showBottomHint,
    playBob,
    hasBobbed: previous.hasBobbed || playBob,
  };
}
